// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"5ddf6a87","453":"d53ba212","524":"6003019c","764":"aecc7606","929":"98c358e1"}[chunkId] + ".chunk.js";
};